import { Button, TooltipTrigger } from '@toggle/design-system';
import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import {
  ContinueContextButtonKeys,
  useRemoteStorage,
} from '~/hooks/use-remote-storage';

import * as S from './ContinueContextButton.styles';

type FirstViewTooltipProps = {
  flag: ContinueContextButtonKeys;
  children: ReactElement;
};

export const FirstViewTooltip = ({ flag, children }: FirstViewTooltipProps) => {
  const { t } = useTranslation('intel');

  const { storeItems } = useRemoteStorage.getState();

  const [open, setOpen] = useState(true);

  const handleGotIt = () => {
    storeItems({ [flag]: 'true' });
    setOpen(false);
  };

  return (
    <>
      {open && <S.BackDrop />}
      <TooltipContainer
        label={
          <div>
            <S.TooltipText>{t('document-message.emptyTooltip')}</S.TooltipText>
            <Button
              label={t('document-message.gotIt')}
              size="small"
              onClick={handleGotIt}
            />
          </div>
        }
        placement="bottom-start"
        trigger={[TooltipTrigger.Click]}
        isOpen={open}
        dismissible={false}
        offsetY={4}
      >
        {children}
      </TooltipContainer>
    </>
  );
};
